import React from 'react';
import { CustomApplicationContextType } from '../common/models/CustomApplicationContextType';

const CustomApplicationContext = React.createContext<CustomApplicationContextType>({
  currentUser: null,
  refreshCurrentUser: () => {},
});

export default CustomApplicationContext;
